import { render, staticRenderFns } from "./RegParentElement.vue?vue&type=template&id=1dda68ee"
import script from "./RegParentElement.vue?vue&type=script&lang=js"
export * from "./RegParentElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports